<validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
<div class="mvd_container mvd_container--pdf" *ngIf="showPage">

        <form *ngIf="!showConfirmation" [formGroup]="form" #f="ngForm">
            <header class="header--well">
                <ul>
                    <li class="header__title">
                        <h2>Account Balance <b>for {{displayName}} ({{customerAccountDetail.customerAccountNumberId}})</b></h2>
                    </li>
                    <li class="w--amount">
                        <div class="pull-right"><b>Account Balance:</b> {{customerAccountDetail.accountBalance.toFixed(2) | dollar}}</div>
                    </li>
                </ul>
            </header>

            <div class="well">
                <fieldset class="print--hidden">
                    <div class="row">
                        <div class="col-sm-4 col-lg-3 mvd_form-group">
                            <label>Requested amount to disburse</label>
                            <p-inputNumber formControlName="amount" mode="currency" currency="USD" inputStyleClass="text-right"></p-inputNumber>
                            <ng-container *ngIf="form.get('amount').touched">
                                <div class="mvd_alert__validation">
                                    <div class="mvd_alert__rule" *ngIf="form.get('amount').hasError('required')">Required</div>
                                </div>
                                <div class="mvd_alert__validation">
                                    <div class="mvd_alert__rule" *ngIf="form.get('amount').hasError('min')">Must be greater than zero</div>
                                </div>
                                <div class="mvd_alert__validation">
                                    <div class="mvd_alert__rule" *ngIf="form.get('amount').hasError('max')">Exceeds account balance</div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </fieldset>

                <div class="row">
                    <div class="col-sm-9">
                        <h2>Disbursement Details</h2>
                        <ul class="list--bulleted--content">
                            <li>Payment will be mailed to: <strong>{{customerAccountDetail.accountAddress?.addressLine1}} <ng-container *ngIf="customerAccountDetail.accountAddress?.addressLine2">, {{customerAccountDetail.accountAddress?.addressLine2}}</ng-container>, {{customerAccountDetail.accountAddress?.city}}, {{jurisdictionDisplayValue}} {{customerAccountDetail.accountAddress?.postalZipCode | zipCode}}</strong></li>
                            <li>Disbursement amount may not exceed the current account balance.</li>
                            <li>The customer will be notified when the check has been sent by email.</li>
                        </ul>
                    </div>
                    <div class="col-sm-3">
                        <div class="well__footer">
                            <div class="btn--group">
                                <button *ngIf="showConfirmation" class="btn--default" type="button" (click)="cancel()">Back</button>
                                <button *ngIf="!showConfirmation" class="btn--default" type="button" (click)="cancel()">Cancel</button>
                                <button class="btn--primary" type="button" [disabled]="form.invalid || disbursementSubmitted" (click)="launchConfirmDisbursementModal()">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

    <ng-container *ngIf="showConfirmation">
        <disbursement-request-confirmation [disbursementRequestId]="disbursementRequestId" [customerAccountDetail]="customerAccountDetail" [newAccountBalance]="newAccountBalance" [displayName]="displayName"></disbursement-request-confirmation>
    </ng-container>
</div>


